/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function downloadFileFromUrl(url: string): void {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
